import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Grid, TextField } from '@mui/material';
import _ from 'lodash';

import FilterPaper from '../../../common/filter_paper';
import SelectField from '../../../common/select_field';
import { getConstantsState } from '../../../../features/product/get_constants';

const PriceListProductFilters = ({ queryParams, onSearchInputChange, onProductTypeChange }) => {
    const [productType, setProductType] = useState(queryParams?.productTypeId || 'none');

    const getConstants = useSelector(getConstantsState);

    const onSearchInputChangeDebounced = _.debounce((value) => onSearchInputChange(value), 600);

    const onSelectProductTypeChange = (event) => {
        const value = event.target.value;
        setProductType(value);
        onProductTypeChange(value === 'none' ? '' : value);
    };

    return (
        <FilterPaper title="Filtry produktów">
            <Grid container spacing={ 3 } alignItems="flex-start">
                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <TextField
                        size="small"
                        label="Szukaj po nazwie"
                        sx={ { maxWidth: 400, width: '100%' } }
                        onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 2 }>
                    <SelectField
                        size="small"
                        label="Typ produktu"
                        value={ productType }
                        onChange={ onSelectProductTypeChange }
                        options={ [{ value: 'none', label: 'Nie wybrano' }, ...getConstants?.data?.productConstants?.FOOD_TYPE?.map(productConstant => ({
                            value: productConstant?.id,
                            label: productConstant?.body
                        }))] }
                    />
                </Grid>

            </Grid>
        </FilterPaper>
    );
};

export default PriceListProductFilters;